import { render, staticRenderFns } from "./ShrinkTransition.vue?vue&type=template&id=71011c2e&scoped=true&"
import script from "./ShrinkTransition.vue?vue&type=script&lang=js&"
export * from "./ShrinkTransition.vue?vue&type=script&lang=js&"
import style0 from "./ShrinkTransition.vue?vue&type=style&index=0&id=71011c2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71011c2e",
  null
  
)

export default component.exports